import assertEventType from 'common/bento/lib/assertEventType';
import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import { ViewerTaxResidenciesFragmentDoc } from '../graphql/fragments/ViewerTaxResidencies.gql';
import { PersonalComplianceUpdateFiscalInformationDocument } from '../graphql/mutations/personalComplianceUpdateFiscalInformation.gql';
import { UpdateOnboardingTaxResidenciesDocument } from '../graphql/mutations/updateOnboardingTaxResidencies.gql';
import { Model } from './model';

export enum Service {
  SendFiscalSituation = 'sendFiscalSituation',
  SendTaxResidencies = 'sendTaxResidencies',
}

const services: MachineServices<Model, Service> = {
  sendFiscalSituation: ({ getModuleData }, event) => {
    assertEventType(event, 'SUBMIT_FISCAL_SITUATION');

    const { data } = event;

    const companyProfileId =
      getModuleData().complianceData.viewer.company?.companyProfileId;
    if (!companyProfileId) {
      throw new Error(
        'Cannot save fiscal situation without a companyProfileId',
      );
    }

    return apolloClient.mutate({
      mutation: PersonalComplianceUpdateFiscalInformationDocument,
      variables: { input: { companyProfileId, ...data } },
    });
  },

  sendTaxResidencies: ({ getModuleData }, event) => {
    assertEventType(event, 'SAVE_TAX_RESIDENCIES');

    const { data } = event;

    const applicationId =
      getModuleData().complianceData.viewer.company?.companyProfileId;
    if (!applicationId) {
      throw new Error('Cannot save tax residencies without an applicationId');
    }

    return apolloClient.mutate({
      mutation: UpdateOnboardingTaxResidenciesDocument,
      // Update the cache manually otherwise the newly created
      // taxResidencies won’t be present under viewer and still be []
      update(cache, { data: mutationResult }) {
        cache.writeFragment({
          data: {
            __typename: 'Viewer',
            taxResidencies:
              mutationResult?.setApplicantTaxResidencies.taxResidencies ?? [],
            uid: getModuleData().complianceData.viewer.uid,
          },
          fragment: ViewerTaxResidenciesFragmentDoc,
          id: cache.identify(getModuleData().complianceData.viewer),
        });
      },
      variables: {
        input: {
          applicationId,
          taxResidencies: data,
        },
      },
    });
  },
};

export default services;
